import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { AuthProvider } from "./AuthContext";
import { RoleProvider } from './RoleContext';

import reportWebVitals from './reportWebVitals';

import 'bootstrap/dist/css/bootstrap.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <RoleProvider>
      <React.StrictMode>
        <Router>
          <App />
        </Router>
      </React.StrictMode>
    </RoleProvider>
  </AuthProvider>
);


reportWebVitals();
